import { Link } from 'react-router-dom';
import { heroContent } from '@/mocks/siteData';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20abstract%20geometric%20composition%20with%20warm%20crimson%20red%20and%20gold%20accents%20on%20soft%20cream%20background%2C%20flowing%20curved%20shapes%2C%20luxurious%20elegant%20atmosphere%2C%20clean%20professional%20aesthetic%2C%20no%20text%2C%20no%20people%2C%20subtle%20gradients%2C%20editorial%20quality%2C%20smooth%20organic%20forms%20with%20warm%20ambient%20lighting&width=1800&height=800&seq=hero-bg-main&orientation=landscape"
        alt="kaiyun.com 官方平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight">
          {heroContent.title}
        </h1>
        <p className="mt-5 md:mt-6 text-base md:text-lg text-background-100/90 max-w-2xl mx-auto leading-relaxed">
          {heroContent.subtitle}
        </p>
        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://aiubo.cn"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-all text-base whitespace-nowrap cursor-pointer"
          >
            <i className="ri-external-link-line"></i>
            {heroContent.ctaPrimary}
          </a>
          <Link
            to="/category/tutorial"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 font-semibold rounded-lg border border-background-50/30 hover:bg-background-50/25 transition-all text-base whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line"></i>
            {heroContent.ctaSecondary}
          </Link>
        </div>
      </div>
    </section>
  );
}